<template>
    <div class="lesson-tab-box">
        <el-tabs v-model="lessonType" @tab-click="handleClick">
            <el-tab-pane v-if="isAdmin || isTeacher" label="我创建的" name="publish"></el-tab-pane>
            <el-tab-pane label="我加入的" name="join"></el-tab-pane>
            <component :is="tabs[lessonType]" :data="data" @edit="beforeEdit" @delete="beforeDelete" @out="beforeOut" @status-change="beforeChange" />
        </el-tabs>
        <div class="right-btn" v-if="isAdmin || isTeacher">
            <el-button class="add-lesson-btn" type="primary" icon="ultralab-icon-publish" size="small" @click="beforeAdd">发布课堂</el-button>
        </div>
        <el-pagination background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper" :total="page.total" :current-page="page.currentPage" :page-size="page.pageSize" :pager-count="page.pagerCount" @current-change="handlePageChange" style="margin-top:15px" hide-on-single-page></el-pagination>
        <el-dialog :title="dialogTitle" :visible.sync="open" width="720px">
            <el-form ref="form" :rules="rules" :model="form" label-width="80px">
                <el-form-item label="课堂名称" prop="lessonName">
                    <el-input v-model.trim="form.lessonName" placeholder="请输入课堂名称"></el-input>
                </el-form-item>
                <!-- <el-form-item label="课堂分类" prop="type">
                    <el-input v-model="form.type" style="width:300px" @focus="typeFoucs"></el-input>
                </el-form-item> -->
                <el-form-item label="公开课堂" v-show="overtLesson">
                    <!-- <el-switch v-model="form.publicFlag" :active-value="0" :inactive-value="1"></el-switch> -->
                    <el-select v-model="form.publicFlag" placeholder="请选择">
                        <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学分" prop="credits">
                    <el-input-number v-model.number="form.credits" :min="0" :step="0.5" step-strictly label="请输入学分"></el-input-number>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="form.viewIndex" :min="1" :step="1" step-strictly label="请设置排序"></el-input-number>
                </el-form-item>
                <el-form-item label="课堂描述">
                    <el-input v-model="form.summary" type="textarea" :rows="3" placeholder="请输入课堂描述"></el-input>
                </el-form-item>
                <el-form-item label="课堂封面" prop="avatar">
                    <img class="course-img" :src="form.avatar | filterUrl" alt />
                    <ul class="upload-bg-img">
                        <li v-for="img in courseImgs" :class="{'active': img.src == form.avatar}" @click="form.avatar = img.src" :key="img.id">
                            <img :src="img.src | filterUrl" alt="" />
                        </li>
                        <li class="custom-upload" @click="$refs.file.click()">自定义图片</li>
                        <input type="file" ref="file" @change="uploadFile" accept="image/png,image/jpeg"/>
                    </ul>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="open = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
            <el-dialog width="30%" title="选择分类" :visible.sync="innerVisible" append-to-body>
                <el-tree :data="dictList" :props="defaultProps" default-expand-all @node-click="handleNodeClick"></el-tree>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import lessonListMine from './components/lesson-list-mine'
import lessonListJoin from './components/lesson-list-join'
import { uploadFile } from '@/api/file'
import {
  getMyList, getMyLesson, add, update, remove,
  // duplicateCheck,
  getDetail
} from '@/api/lab/lesson'
import { getOutClass } from '@/api/lab/lesson2user'
import { getMajorDictTree } from '@/api/system/dict'
import { getDept } from '@/api/system/dept'
import { convertLocalPath } from '@/utils/localAvartSrc'
import TreeUtil from '@/utils/treeUtil'

export default {
    data () {
        const validateName = (rule, value, callback) => {
            if (!value || value === '') {
                callback(new Error('请输入课堂名称'))
            } else {
                // 远程验证课堂名称是否存在
                // duplicateCheck(value, this.form.id).then(res => {
                //     if (res) {
                //         callback(new Error('课堂已存在，请重新命名'))
                //     }
                    callback()
                // })
            }
        }
        return {
            innerVisible: false,
            dictList: [],
            defaultProps:{
                children: 'children',
                label: 'dictValue'
            },
            overtLesson: null,
            dialogTitle: '发布课堂',
            page: {
                currentPage: 1, // 当前页
                pageSize: 5, // 每页条目数
                total: 0
            },
            options:[
                {
                    value: 0,
                    label:'公开'
                },
                {
                    value: 1,
                    label:'私有'
                },
                {
                    value: 2,
                    label:'申报课堂'
                }
            ],
            open: false,
            tabs: {
                publish: 'lessonListMine',
                join: 'lessonListJoin'
            },
            // 列表数据
            data: [],
            typeList: [],
            activeStatus: '1',
            // 列表类型 publish我创建的课堂，join我加入的课堂，like我收藏的课堂
            lessonType: 'publish',
            form: {},
            rules: {
                lessonName: [
                    { required: true, message: '请填写课堂名称', trigger: 'blur' },
                    { validator: validateName, trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择课堂分类', trigger: 'change' }
                ]
            },
          courseImgs: [
            {id: 1, src: '/assets/img/lesson_icon_1.png'},
            {id: 2, src: '/assets/img/lesson_icon_2.png'},
            {id: 3, src: '/assets/img/lesson_icon_3.png'},
            {id: 4, src: '/assets/img/lesson_icon_4.png'},
            {id: 5, src: '/assets/img/lesson_icon_5.png'},
            {id: 6, src: '/assets/img/lesson_icon_6.png'},
            {id: 7, src: '/assets/img/lesson_icon_7.png'},
            {id: 8, src: '/assets/img/lesson_icon_8.png'},
            {id: 9, src: '/assets/img/lesson_icon_9.png'},
            {id: 10, src: '/assets/img/lesson_icon_10.png'},
            {id: 11, src: '/assets/img/lesson_icon_11.png'},
            {id: 12, src: '/assets/img/lesson_icon_12.png'},
            {id: 13, src: '/assets/img/lesson_icon_13.png'}
          ]
        }
    },
    components: {
        lessonListMine,
        lessonListJoin
    },
    computed: {
        ...mapGetters(['userInfo', 'isAdmin', 'isTeacher', 'isStudent']),
    },
    created () {
        if (this.isAdmin || this.isTeacher) {
            this.lessonType = 'publish'
            this.getPublicList()
        } else {
            this.lessonType = 'join'
            this.getStudyList()
        }
        //this.getTypes()
        getMajorDictTree(this.form.tenantCode).then(res => {
            const { dictList = [], genId } = res;
            //const index = this.$refs.crud.findColumnIndex("type");
            //this.option.column[index].dictData = new TreeUtil(dictList, 'id', null, genId).toTree();
            this.dictList = new TreeUtil(dictList, 'id', 'parentId', genId).toTree();
        })
    },
    methods: {
        // page 改变时会触发
        handlePageChange (page) {
            this.$set(this.page, 'currentPage', page)
            this.getLessonList()
        },
        convertLocalPath(src){
            return convertLocalPath(src)
        },
        handleNodeClick(data) {
            this.$set(this.form,'type',data.dictValue)
            this.innerVisible = false;
            if(data.code == "course_major"){
                var majorName = data.dictValue
                // 只选择了专业
                this.form = {
                    ...this.form,
                    majorName
                }
            } else if(data.code == "course_label") {
                // 选了标签，还要把majorName匹配上去
                var labelName = data.dictValue
                this.form = {
                    ...this.form,
                    labelName
                }
                this.dictList.map(ite => {
                ite.children.map(k => {
                    k.children.map(v => {
                        if(v.dictValue == data.dictValue){
                            var majorName =  k.dictValue
                            this.form = {
                                ...this.form,
                                majorName
                            }
                        }
                    })
                })
                })
            }
        },
        typeFoucs(){
            this.innerVisible = true
        },
        beforeAdd () {
            const { deptId, id } = this.userInfo
            this.form = {
                publicFlag: 1, // 0 公开课  1 私有课
                credits: 0,
                avatar: this.courseImgs[0].src,
                viewIndex: 1,
                delFlag: 0
            }
            if (this.overtLesson === null)
                getDept(deptId, id).then(res => {
                    const { overtLesson } = res
                    this.overtLesson = overtLesson
                    this.$set(this.form, 'publicFlag', overtLesson ? 0 : 1)
                })
            this.dialogTitle = '创建课堂'
            this.open = true
        },
        /**
         * 点击标签事件
         */
        beforeChange (status) {
            this.activeStatus = status
            if (this.lessonType == 'publish')
                this.getPublicList({ 'status': status })
            else if (this.lessonType == 'join')
                this.getStudyList({ 'status': status })
        },
        /**
         * 执行删除操作
         */
        beforeDelete (uid) {
            this.$confirm('此操作将永久删除该课堂, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                remove([uid]).then(() => {
                    this.$message.success('删除成功!')
                    this.getPublicList()
                })
            }).catch(() => { })
        },
        /**
         * 执行结课操作
         */
        // beforeEnd (id) {
        //     this.$confirm('是否确定结课?', '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         end([id]).then(() => {
        //             this.$message.success('操作成功!')
        //             this.getPublicList()
        //         })
        //     }).catch(() => { })
        // },
        /**
         * 学生退出课堂
         */
        beforeOut(uid){
            this.$confirm('此操作将退出该课堂, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                getOutClass(uid).then(()=>{
                    this.$message.success('操作成功!')
                    this.getStudyList()
                })
            }).catch(() => { })
        },
        /**
         * 打开编辑弹窗
         */
        beforeEdit (uid) {
            this.dialogTitle = '编辑课堂'
            const { deptId, id } = this.userInfo
            if (this.overtLesson === null)
                getDept(deptId, id).then(res => {
                    const { overtLesson } = res
                    this.overtLesson = overtLesson
                })
            getDetail(uid).then(res => {
                if (!res.avatar) res.avatar = ''
                res.type = (res.labelName == null ? res.majorName : res.labelName)
                this.form = res
                this.open = true
            })
        },
        handleClick (i) {
            this.lessonType = i.name
            this.page = {
                currentPage: 1, // 当前页
                pageSize: 5, // 每页条目数
                total: 0
            }
            this.getLessonList()
        },
        // 获取课堂列表
        getLessonList () {
            this.data = []
            this.activeStatus = status
            if (this.lessonType === 'publish')
                this.getPublicList()
            else if (this.lessonType === 'join')
                this.getStudyList()
        },
        // getTypes () {
        //     selectDictByService({
        //         service: 'lab_type'
        //     }).then(res => {
        //         this.typeList = res
        //     })
        // },
        /**
         * 获取我发布的课堂列表
         */
        getPublicList (params = {
            status: 1
        }) {
            const { currentPage, pageSize } = this.page
            getMyList(currentPage, pageSize, params).then(res => {
                const { list, totalCount } = res
                this.page.total = totalCount
                this.data = list
            })
        },
        /**
         * 获取我加入的课堂
         */
        getStudyList (params = {
            status: 1
        }) {
            const { currentPage, pageSize } = this.page
            getMyLesson(currentPage, pageSize, params).then(res => {
                const { list, totalCount } = res
                this.page.total = totalCount
                this.data = list
            })
        },
        submit () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let opFun = this.form.id ? update : add
                    this.form.avatar = this.convertLocalPath(this.form.avatar)
                    this.form.type = 1
                    opFun(this.form).then(() => {
                        this.open = false
                        this.$message.success('操作成功')
                        this.type = 0
                        this.activeName = '1'
                        this.getPublicList()
                    })
                } else
                    return false
            })
        },
        uploadFile (e) {
            const file = e.target.files[0]
            const a = (Number(file.size)/1024/1024).toFixed(2)<2
            const b = file.type === 'image/jpeg'
            const c = file.type === 'image/png'
            if(a && (b || c)){
              // 课堂封面图
                uploadFile(file, `lesson/avatar/user/${this.userInfo.id}/`).then(res => {
                  window.console.debug(res)
                    this.form.avatar = res.originalPath
                })
            }else{
                this.$message.warning('上传图片大小不能超过2M,且必须为JPG或PNG格式!')
            }
        }
    }
}
</script>

<style lang="less">
.lesson-tab-box {
    position: relative;
    .el-form {
        .el-select,
        .el-input-number {
            width: 100%;
        }
    }
    .right-btn {
        position: absolute;
        top: 0;
        right: 0;
    }
    .lesson-status {
        margin-top: 24px;
        margin-bottom: 24px;
        .el-tag {
            cursor: pointer;
            & + .el-tag {
                margin-left: 18px;
            }
        }
    }
    .lesson-list {
        margin: -10px 0;
    }
    .lesson-item {
        padding: 10px 0;
        border-bottom: 1px solid #efefef;
        &:last-child {
            border-bottom: none;
        }
        > .el-col {
            vertical-align: text-bottom;
        }
    }
    .lesson-info {
        > .el-col {
            vertical-align: text-top;
        }
    }
    .lesson-pic {
        .el-image {
            width: 100%;
            height: 118px;
        }
        & + .el-col {
            padding-left: 24px;
        }
    }
    .lesson-main {
        & + .el-col {
            padding-left: 56px;
        }
    }
    .lesson-title {
        font-size: 1em;
    }
    .lesson-synopsis,
    .lesson-summary {
        font-size: 0.9em;
    }
    .lesson-synopsis {
        > span {
            color: #bdbdbd;
            > i {
                font-style: normal;
            }
        }
    }
    .lesson-summary {
        margin-top: 12px;
        height: 40px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
    .lesson-body {
        font-size: 0.7em;
        margin-top: 6px;
        > span {
            margin-right: 12px;
            > i {
                font-style: normal;
            }
        }
    }
    .lesson-action {
        text-align: right;
        .bottom {
            margin-top: 72px;
        }
    }
    .right-btn {
        position: absolute;
        top: -6px;
        right: 0;
    }
    .add-lesson-btn {
        font-size: 15px;
        position: relative;
    }
}
.course-img {
    width: 260px;
    height: 150px;
}
.upload-bg-img {
    overflow: hidden;
    li {
        list-style: none;
        width: 180px;
        float: left;
        padding: 0;
        margin: 0 10px 10px 0;
        height: 105px;
        img {
            cursor: pointer;
            width: 100%;
        }
    }
    .active {
        border: 2px solid;
    }
    .custom-upload {
        cursor: pointer;
        background-color: #e0dddd;
        line-height: 105px;
        text-align: center;
    }
    input {
        display: none;
    }
}
</style>
